// --- Mostra rata classica a 84 mesi sotto al prezzo ---

function addLoanSimulationInfo() {

  function parsePrice(text) {
    if (!text) return 0;
    return parseFloat(
      text
        .replace(/\./g, '')       // rimuove i punti delle migliaia
        .replace(',', '.')        // sostituisce la virgola con il punto
        .replace(/[^\d.]/g, '')  // rimuove tutto ciò che non è numero o punto
    ) || 0;
  }

    // Ciclo su tutti i contenitori prezzo
    const compareAtPrice = document.querySelector('.sale-price');
    const normalPrice = document.querySelector('.product__price');

    let classicInfoEl = document.querySelector('.loan-simulated-price');
    if (classicInfoEl) {
        // Prezzo base (considera compareAtPrice se presente)
        let basePrice = parsePrice(
        compareAtPrice?.innerText || normalPrice?.innerText
        );

        const immatricolazione = 300;
        const prezzoTotale = basePrice + immatricolazione;

        // Calcolo rata classica con 7,9% annuo su 84 mesi
        const durata = 71;
        const TA = 0.079;
        const i = TA / 12;
        const factor = Math.pow(1 + i, durata);
        const rata = prezzoTotale * (i * factor) / (factor - 1);
        const rataMensile = Math.floor(rata);

        classicInfoEl.innerHTML = `
        <div>
            Finanziamento da <strong>€${rataMensile} / mese*</strong> 
            <br>
            <small>* A 84 mesi con anticipo €0. Importo approssimativo non vincolante.</small>
        </div>
        `;
    }

}

// Avvio
addLoanSimulationInfo();
